<script setup>
  defineProps({
    imageUrl: {
      type: String,
      required: true,
    },
  });
</script>

<template>
  <div class="w-full h-full overflow-hidden">
    <img
      :src="imageUrl"
      class="w-full h-full object-cover" />
  </div>
</template>
